import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useNotificationContext } from '@/features/notifications';
import { useProcInstantiate } from '@/shared/api';
import { PageRoutes } from '@/shared/router';
import { useFullScreenLoaderEffect } from '@/shared/ui';
import { captureError } from '@/shared/utils';

export const ProcPreviewPage = () => {
  const { procId = '' } = useParams();
  const { showNotification } = useNotificationContext();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { isAuthenticated } = useAuth0();

  const { mutate: instantiateProc, isLoading } = useProcInstantiate();
  useFullScreenLoaderEffect(isLoading);

  useEffect(() => {
    try {
      instantiateProc(
        { pathParams: { id: procId } },
        {
          onSuccess: ({ instanceId, code }) => {
            const url = isAuthenticated
              ? `/dashboard/proc/instance/${instanceId}`
              : `/procs/${instanceId}/${code}`;
            navigate(url, { state });
          },
          onError: (error) => {
            if (error.message) {
              showNotification({
                type: 'error',
                message: 'Proc instantiate error',
                description: error.message,
              });
            }
            if (error.status === 404) {
              navigate(PageRoutes.NOT_FOUND, { replace: true });
            }
            captureError(error, {
              module: 'proc_instantiate_modal_on_error_on_submit',
              action: 'on_submit',
            });
          },
        },
      );
    } catch (error) {
      captureError(error, {
        module: 'proc_instantiate_modal_on_error_on_submit',
        action: 'on_submit',
      });
    }
  }, [
    instantiateProc,
    isAuthenticated,
    navigate,
    procId,
    showNotification,
    state,
  ]);

  return null;
};
